import React from 'react'
import CurrencyInputField from 'react-currency-input-field'
import _ from 'lodash'
import { 
  FormFeedback,
  InputGroup, InputGroupAddon, InputGroupText 
} from 'reactstrap'

const CurrencyInput = ({
  currency,
  value,
  onChangeValue,
  disabled,
  invalid,
  width
}) => {
  return(
    <InputGroup style={{ width: width || 'fit-content' }} >
      <CurrencyInputField 
        className={ `form-control ${ invalid && 'is-invalid' }` }
        disabled={ disabled }
        value={ value }
        allowNegativeValue={ false }
        decimalSeparator={ currency.decimal_separator }
        groupSeparator={ currency.decimal_separator === '.' ? ',' : '.' }
        onValueChange={ onChangeValue } />
      <InputGroupAddon addonType="append">
        <InputGroupText>{ currency.name }</InputGroupText>
      </InputGroupAddon>
      <FormFeedback className={ `${ invalid && 'd-block' }` } >{ invalid }</FormFeedback>
    </InputGroup>
  )
}

export default CurrencyInput